import { render, staticRenderFns } from "./PaymentReport.vue?vue&type=template&id=5ca42e1f&scoped=true&"
import script from "./PaymentReport.vue?vue&type=script&lang=js&"
export * from "./PaymentReport.vue?vue&type=script&lang=js&"
import style0 from "./PaymentReport.vue?vue&type=style&index=0&id=5ca42e1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca42e1f",
  null
  
)

export default component.exports